import { useHistory, useLocation } from "react-router-dom";
import { DropdownButton } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";

type Props = {
  entityId: number;
  entityName: string;
};

/**
 * Row ⋯ menu for the Entities grid. "Create entity onboarding case" opens the entity wizard;
 * "Link case to this entity" navigates to the link-case route owned by COMP-4636.
 */
export const RowActionsMenu = ({ entityId, entityName }: Props) => {
  const history = useHistory();
  const location = useLocation();
  const clientId = new URLSearchParams(location.search).get("clientId");

  const buildParams = () => {
    const params = new URLSearchParams();
    params.set("entityId", String(entityId));
    if (entityName) params.set("entityName", entityName);
    if (clientId) params.set("clientId", clientId);
    return params;
  };

  const handleCreateCase = () => {
    history.push(`${globalEnv.complianceRoute}/create-case/entity?${buildParams().toString()}`);
  };

  const handleLinkCase = () => {
    history.push(`${globalEnv.complianceRoute}/entities/link-case?${buildParams().toString()}`);
  };

  return (
    <DropdownButton
      align="right"
      usePortal
      hideIcon
      variant="muted"
      childAsIcon={{ type: "ellipsis-h" }}
      aria-label="Entity actions"
      data-testid="entity-row-actions"
    >
      <DropdownButton.Action
        onSelect={handleCreateCase}
        data-cy="create-entity-onboarding-case"
      >
        Create entity onboarding case
      </DropdownButton.Action>
      <DropdownButton.Action onSelect={handleLinkCase} data-cy="link-case-to-entity">
        Link case to this entity
      </DropdownButton.Action>
    </DropdownButton>
  );
};

export default RowActionsMenu;
